// Window.jsx
const Window = ({ text, content, onClose, className = "" }) => {
    return (
        <div className={`bg-white border border-gray-300 rounded-lg overflow-hidden relative flex flex-col items-center justify-center ${className}`}>
            <div className="w-full bg-blue-400 text-white top-0 px-3 py-1 flex justify-between items-center text-sm font-bold shrink-0 z-[10]">
                <div className="ml-[1%] text-white text-sm">{text}</div>
                <div className="flex gap-[2px]">
                    <div className="w-3 h-3 bg-white border border-gray-300 flex items-center justify-center text-[10px] text-gray-500">−</div>
                    <div className="w-3 h-3 bg-white border border-gray-300 flex items-center justify-center text-[10px] text-gray-500">▢</div>
                    <button
                        className="w-3 h-3 bg-white border border-gray-300 flex items-center justify-center text-[10px] text-gray-500"
                        onClick={onClose}
                    >
                        X
                    </button>
                </div>
            </div>
            <div className="w-full grow">{content}</div>
        </div>
    );
};

export default Window;
